<template>
  <v-app>
    <v-container
      grid-list-md
      :dark='darkMode'
    >
      <v-breadcrumbs
        large
        :items="items"
        divider=">"
      ></v-breadcrumbs>
      <template>
  <v-row justify="center">
    <v-dialog v-model="overWriteDialog" persistent max-width="450">
      <v-card>
        <v-card-title class="headline"><v-icon color='red'>warning</v-icon>Warning</v-card-title>
        <v-card-text>The following files already exists on server, click contiune to overwrite or re-name the files and retry again.
          <br>
        <li v-for='(item,index) in overwriteFile' :key='index'>{{item}}</li>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="overWriteDialog = false">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="confirmUpload(),overWriteDialog = false">Contiune</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
      <template>
        <v-layout>
          <v-flex
            sm10
            offset-sm1
          >
            <v-card>
              <v-banner
                v-if='!user.filesUploaded'
                two-line
              >
                <v-avatar
                  slot="icon"
                  color="yellow accent-4"
                  size="40"
                >
                  <v-icon color="white">
                    warning
                  </v-icon>
                </v-avatar>
                Please upload your genetic test report here. Our team will review your report and provide a summary of the results and recommendations within 2 business days.
              </v-banner>
              <v-banner
                v-else
                two-line
              >
                <v-avatar
                  slot="icon"
                  color="green accent-4"
                  size="40"
                >
                  <v-icon color="white">
                    check
                  </v-icon>
                </v-avatar>
                Thank you! We've got your report.You may upload additonal report below, we will review your testing report and have your summary ready in 2-3 days. View your upload history <router-link to="account">here</router-link>
              </v-banner>
              <v-file-input
                class='ma-3'
                :rules="rules"
                clearable
                accept="image/png, image/jpeg, image/bmp,application/pdf,"
                placeholder="Please Upload your Documents Here"
                validate-on-blur
                prepend-icon="mdi-file"
                chips
                counter
                :success="uploadSuccess"
                outlined
                v-model="files"
                multiple
              ></v-file-input>
              <v-btn
                :disabled="files.length === 0"
                color="blue-grey"
                class="ma-2 white--text"
                @click="uploadFile()"
                :loading="loadingbtn"
              >
                Upload
                <v-icon
                  right
                  dark
                >cloud_upload</v-icon>
              </v-btn>

            </v-card>
            <div class="mt-5 headline">Reports</div>
                 <v-divider
        class="mb-3 mt-2"
        color='blue'
        width='10%'

      ></v-divider>
            <v-row>
              <v-col
                md="4"
                v-for="(item,index) in user.variants"
                :key='index'
              >
                <v-card
                  class="pa-2"
                  outlined
                >
                  <v-list-item three-line>
                    <v-list-item-content>
                      <v-list-item-title :class="statusColor(item.reportStatus)">{{item.reportStatus}}</v-list-item-title>
                      <v-list-item-subtitle>Date: {{item.reportDate}}</v-list-item-subtitle>
                      <v-list-item-subtitle>Lab: {{item.labName}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-icon color='blue' size='80'>mdi-file-outline</v-icon>
                  </v-list-item>

                  <v-card-actions>
                    <v-btn :disabled='item.reportStatus !== "Ready"'
                      @click="dialog = true; selectedVariant=item"
                    >View</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <template>
              <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
              >
               <v-card>
                  <v-toolbar
                    dark
                    color="primary"
                  >
                    <v-btn
                      icon
                      dark
                      @click="dialog = false;darkMode = false"
                    >
                      <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Genetic Test Results for {{user.info.name}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                      target='_blank'
                      color='primary'
                      :href='reportURL()'
                    >View Report</v-btn>
                    <v-toolbar-items>
                      <v-btn
                        title='night mode'
                        @click='darkMode? darkMode = false : darkMode = true'
                        icon
                      >
                        <v-icon>brightness_3</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-layout>
                    <v-flex
                      sm10
                      offset-sm1
                    >
               <testResult :variant='selectedVariant'/>

                    </v-flex>
                  </v-layout>
                </v-card>
              </v-dialog>

            </template>

          </v-flex>
        </v-layout>
      </template>
    </v-container>
  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import testResult from '../components/geneticTestResult/TestResult'
export default {
  components: {
    testResult
  },
  computed: {
    ...mapFields([
      'user',
    ]),
  },
  data () {
    return {
      overwriteFile : [],
      overWriteDialog : false,
      selectedVariant : null,
      dialog: false,
      loadingbtn: false,
      uploadSuccess: false,
      rules: [
        value => (value[0] || {}).size < 5000000 || 'file size should be less than 5 MB!',
      ],
      darkMode: false,
      files: [],
      items: [
        {
          text: 'Home',
          disabled: false,
          to: '/home'
        },
        {
          text: 'Genetic Test Result',
          disabled: true,

        }],
      trialData: null
    }
  },
  mounted () {

  },
  watch: {
    darkMode: function (val) {
      if (val === true) {
        this.$vuetify.theme.dark = true
      } else {
        this.$vuetify.theme.dark = false
      }
    }
  },
  methods: {
        statusColor(item){
      switch (item) {
        case "Ready" :
        return "headline mb-1 green--text"
        case "Need Additonal Info" :
        return "title mb-1 red--text"
        case "Under Review" :
         return "headline mb-1 grey--text"
         default :
         return "headline mb-1 grey--text"
      }

    },
    reportURL(){
      if(!this.selectedVariant) {return ""}
        var fname = this.selectedVariant.sourceDoc.substring(this.selectedVariant.sourceDoc.lastIndexOf("/") + 1)
        var result = this.user.filesURL.filter(file => {return file.fileName === fname })[0]
        return result.fileURL
    },
    validateFileName(){
      this.overwriteFile = []
      //check file name against user state object
      this.files.forEach(file => {
        var result = this.user.filesUploaded.filter(item=>{return item.fileName === file.name})[0]
        if(result !== undefined){
          this.overwriteFile.push(result.fileName)
        }
      });
      if (this.overwriteFile.length >= 1){
        this.overWriteDialog = true
      }else{
        this.confirmUpload()
      }
    },
    confirmUpload(){
      this.loadingbtn = true
      var uploadForm = new FormData()
      uploadForm.append('idToken', this.user.idToken)
      uploadForm.append('uid', this.user.uid)
      this.files.forEach(file => {
        uploadForm.append('file', file)
      });
      this.$axios({
        method: 'post',
        url: 'https://us-central1-genetic-trust-dev.cloudfunctions.net/patientFilesUpload',
        data: uploadForm,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then((response) => {
          //handle success
          this.uploadSuccess = true
          this.files = []
          this.loadingbtn = false
        })
        .catch((response) => {
          //handle error
          this.files = []
        });
    },
    uploadFile () {
      this.validateFileName()
    },
    changeSort (column) {

      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>


<style scoped>
.blockquote {
  color: black;
}
</style>
